import WelcomeDeck from './WelcomeDeck'

export default WelcomeDeck
